/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ value: NonNullable<unknown> }} Admin_Subscription_Rights_OverriddenInputs */

const fr_admin_subscription_rights_overridden = /** @type {(inputs: Admin_Subscription_Rights_OverriddenInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Corrigé à la main (palier : ${i?.value})`)
};

/**

* @param {Admin_Subscription_Rights_OverriddenInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const admin_subscription_rights_overridden = /** @type {((inputs: Admin_Subscription_Rights_OverriddenInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Subscription_Rights_OverriddenInputs, { locale?: "fr" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_admin_subscription_rights_overridden(inputs)
});